// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DaterangepickerController from "./daterangepicker_controller"
application.register("daterangepicker", DaterangepickerController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import HugeUploaderController from "./huge_uploader_controller"
application.register("huge-uploader", HugeUploaderController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import RemoveElementController from "./remove_element_controller"
application.register("remove-element", RemoveElementController)

import ToggleClassController from "./toggle_class_controller"
application.register("toggle-class", ToggleClassController)
